/**
 * Erros do fluxo de usuários que têm mensagem acionável em português. Sem
 * isso o operador via a mensagem crua do backend, em inglês e citando UUIDs.
 */
const USER_ERROR_MESSAGE: Record<string, string> = {
	USER_BELONGS_TO_ANOTHER_ACCOUNT: "Este e-mail já pertence a outra empresa.",
	USER_DOESNT_BELONG_TO_SAME_SELLER_GROUP:
		"Você não administra nenhuma operação deste usuário.",
	USER_DOES_NOT_HAVE_PERMISSION_TO_CHANGE_PASSWORD:
		"Você não tem nível de acesso suficiente para alterar a senha deste usuário.",
	CANNOT_GRANT_HIGHER_USER_TYPE:
		"Você não pode conceder um nível de acesso superior ao seu.",
	SELLER_GROUP_WITHOUT_ACCOUNT:
		"Esta operação ainda não está vinculada a uma empresa. Fale com o suporte.",
	SELLER_GROUPS_FROM_DIFFERENT_ACCOUNTS:
		"As operações selecionadas pertencem a empresas diferentes.",
	SELLER_NOT_FOUND:
		"Uma das filiais selecionadas não está mais disponível. Recarregue a página e tente de novo.",
	ROLE_NOT_FOUND: "Selecione uma permissão válida para esta operação.",
};

export const resolveErrorMessage = (error: unknown): string => {
	const response = (
		error as {
			response?: {
				data?: {
					message?: unknown;
					code?: string;
					params?: { account_name?: unknown };
				};
			};
		}
	)?.response;

	// O backend só envia o nome da conta conflitante para usuários INTERNAL.
	const accountName = response?.data?.params?.account_name;
	if (
		response?.data?.code === "USER_BELONGS_TO_ANOTHER_ACCOUNT" &&
		typeof accountName === "string" &&
		accountName
	) {
		return `Este e-mail já pertence a outra empresa: ${accountName}.`;
	}

	const mapped = response?.data?.code
		? USER_ERROR_MESSAGE[response.data.code]
		: undefined;
	if (mapped) return mapped;

	const message = response?.data?.message;
	if (typeof message === "string") return message;
	if (Array.isArray(message) && typeof message[0] === "string")
		return message[0];
	return "Não foi possível concluir a operação. Tente novamente.";
};
